// extracted by css-extract-rspack-plugin
export default {"spaceXXSmall":"4px","micGroup":"mic-control__micGroup___x0aiK"};